import {findTransactions} from '../api/common';

export const fetchTransactions = (verifiedMeUserId, caseId, searchCriteria, roles) => ({
    type: 'FETCH_TRANSACTIONS',
    payload: findTransactions(verifiedMeUserId, caseId, searchCriteria).then(res => {
        return res;
    }),
});

export const clearUserTransactions = () => ({
    type: 'CLEAR_USER_TRANSACTIONS',
});

export const setMarkedTransactions = markedTxns => ({
    type: 'SET_MARKED_TRANSACTIONS',
    payload: markedTxns,
});

export const clearMarkedTransactions = () => ({
    type: 'CLEAR_MARKED_TRANSACTIONS',
});
